import { useEffect } from "react";
import {
  clearAuth,
  getStoredRefreshToken,
  getStoredToken,
  isIdleTimedOut,
  markSessionExpired,
  refreshSession,
  touchSessionActivity,
  willTokenExpireSoon,
} from "../../services/authService";

const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
const CHECK_INTERVAL_MS = 30 * 1000;
const REFRESH_THRESHOLD_MS = 2 * 60 * 1000;

const SessionManager = () => {
  useEffect(() => {
    const handleActivity = () => {
      if (getStoredToken()) {
        touchSessionActivity();
      }
    };

    const activityEvents = [
      "click",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
    ];

    activityEvents.forEach((eventName) =>
      window.addEventListener(eventName, handleActivity, { passive: true })
    );

    const interval = window.setInterval(async () => {
      const token = getStoredToken();
      const refreshToken = getStoredRefreshToken();

      if (!token || !refreshToken) {
        return;
      }

      if (isIdleTimedOut(IDLE_TIMEOUT_MS)) {
        clearAuth();
        markSessionExpired();

        if (window.location.pathname !== "/") {
          window.location.replace("/");
        }
        return;
      }

      if (willTokenExpireSoon(token, REFRESH_THRESHOLD_MS)) {
        try {
          await refreshSession();
        } catch {
          clearAuth();
          markSessionExpired();

          if (window.location.pathname !== "/") {
            window.location.replace("/");
          }
        }
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      activityEvents.forEach((eventName) =>
        window.removeEventListener(eventName, handleActivity)
      );
      window.clearInterval(interval);
    };
  }, []);

  return null;
};

export default SessionManager;